export type PaginationOptions = {
    pageIndex: number
    pageSize: number
    columnFilters?: any
    additionalFilters?: any
    sorting?: any
}

export enum ResponseStatus {
    ERROR = 'error',
    SUCCESS = 'success',
}
